import React from 'react'
import {Login} from 'attendee/Auth/Login'
import {Route, Routes} from 'react-router-dom'
import {pathForRoute, routes} from 'routes/routes'
import {Index} from 'attendee'
import {Register} from 'attendee/Auth/Register'
import {VerifyEmail} from 'attendee/Auth/VerifyEmail'
import AttendeeEventsListProvider from 'attendee/providers/AttendeeEventsListProvider'
import {Billing} from 'attendee/Billing'
import {Tickets} from 'attendee/Tickets'
import {AuthReqired} from 'routes/AuthReqired'
import {Profile} from 'attendee/Auth/Profile'
import {PasswordRecover} from 'attendee/Auth/PasswordRecover'
import {GoogleCallback} from 'attendee/Auth/GoogleCallback'
import {Info} from 'attendee/Info'
import {Search} from 'attendee/Search'
import {Help} from 'attendee/Help'
import EventProvider from 'event/providers/EventProvider'
import {View} from 'event/View'
import EventPreviewProvider from 'event/providers/EventPreviewProvider'
import {Preview} from 'event/Preview'
import {Autologin} from 'attendee/Auth/Autologin'
import {Prices} from 'attendee/Prices'
import {Certificates} from 'attendee/Certificates'
import {Purchases} from 'attendee/Purchases'
import {TermsAndConditions} from 'attendee/TermsAndConditions'
import {CookiesPolicy} from 'attendee/CookiesPolicy'
import {PrivacyPolicy} from 'attendee/PrivacyPolicy'
import {ApiDocs} from 'apiDocs'
import {LoadingPage} from 'attendee/LoadingPage'
import {Invoices} from 'attendee/Invoices'
import InvoicesModalsProvider from 'attendee/Invoices/InvoicesModalsProvider'
import AttendeeTransactionsProvider from 'attendee/Invoices/Transactions/AttendeeTransactionsProvider'
import AttendeeInvoicesProvider from 'attendee/Invoices/Invoices/AttendeeInvoicesProvider'
import {AffiliateReceiver} from 'attendee/Affiliate'
import {ForAffiliates} from 'attendee/ForAffiliates'
import {ForOrganizations} from 'attendee/ForOrganizations'
import {BlogIndex} from 'blog'
import {BlogPost} from 'blog/BlogPost'
import {NavigateLocalized} from 'i18n/NavigateLocalized'
import {useRoutesLocationUnderLocale} from 'i18n/localePaths'

export function AttendeeRoutes() {
  const routesLocation = useRoutesLocationUnderLocale()
  return (
    <Routes location={routesLocation}>
      <Route path={pathForRoute(routes.login)} element={<Login />} />

      <Route path={pathForRoute(routes.register)} element={<Register />} />

      <Route
        path={pathForRoute(routes.verifyEmail)}
        element={<VerifyEmail />}
      />

      <Route
        path={pathForRoute(routes.auth.google)}
        element={<GoogleCallback />}
      />

      <Route
        path={pathForRoute(routes.passwordRecover)}
        element={<PasswordRecover />}
      />

      <Route path={pathForRoute(routes.profile)} element={<Profile />} />

      <Route path={pathForRoute(routes.billing)} element={<Billing />} />

      <Route
        path={pathForRoute(routes.tickets)}
        element={
          <AuthReqired>
            <Tickets />
          </AuthReqired>
        }
      />

      <Route
        path={pathForRoute(routes.invoices)}
        element={
          <AuthReqired>
            <InvoicesModalsProvider>
              <AttendeeTransactionsProvider>
                <AttendeeInvoicesProvider>
                  <Invoices />
                </AttendeeInvoicesProvider>
              </AttendeeTransactionsProvider>
            </InvoicesModalsProvider>
          </AuthReqired>
        }
      />

      <Route
        path={pathForRoute(routes.certificates)}
        element={
          <AuthReqired>
            <Certificates />
          </AuthReqired>
        }
      />

      <Route
        path={pathForRoute(routes.purchases)}
        element={
          <AuthReqired>
            <Purchases />
          </AuthReqired>
        }
      />
      <Route
        path={pathForRoute(routes.loadingPage)}
        element={<LoadingPage />}
      />
      <Route path={pathForRoute(routes.cookies)} element={<CookiesPolicy />} />
      <Route
        path={pathForRoute(routes.terms)}
        element={<TermsAndConditions />}
      />
      <Route path={pathForRoute(routes.privacy)} element={<PrivacyPolicy />} />
      <Route path={pathForRoute(routes.apiDocs)} element={<ApiDocs />} />
      <Route path={pathForRoute(routes.info)} element={<Info />} />
      <Route path={pathForRoute(routes.prices)} element={<Prices />} />
      <Route
        path={pathForRoute(routes.organizations)}
        element={<ForOrganizations />}
      />
      <Route
        path={pathForRoute(routes.affiliates)}
        element={<ForAffiliates />}
      />
      <Route path={pathForRoute(routes.help)} element={<Help />} />
      <Route path={pathForRoute(routes.autologin)} element={<Autologin />} />
      <Route path={pathForRoute(routes.blog.root)} element={<BlogIndex />} />
      <Route
        path={pathForRoute(routes.blog[':blogSlug'].root)}
        element={<BlogPost />}
      />

      <Route
        path={pathForRoute(routes.search)}
        element={
          <AttendeeEventsListProvider>
            <Search />
          </AttendeeEventsListProvider>
        }
      />

      <Route
        index
        element={
          <AttendeeEventsListProvider>
            <Index />
          </AttendeeEventsListProvider>
        }
      />

      <Route
        path={pathForRoute(routes.p[':affiliateToken'].root)}
        element={<AffiliateReceiver />}
      />

      <Route
        path={pathForRoute(routes[':eventSlug'].root)}
        element={
          <EventProvider>
            <View />
          </EventProvider>
        }
      />

      <Route
        path={pathForRoute(routes[':eventSlug'].preview)}
        element={
          <EventPreviewProvider>
            <Preview />
          </EventPreviewProvider>
        }
      />

      <Route
        path="*"
        element={<NavigateLocalized to={routes.index} replace />}
      />
    </Routes>
  )
}
